export const PAGE_IDS = [
  "home",
  "account",
  "teams",
  "leagues",
  "play",
  "forums",
  "disputes",
  "contact",
];

const PAGE_SET = new Set(PAGE_IDS);

const ROUTE_SUBPAGES = {
  account: new Set(["profile"]),
  teams: new Set(["overview", "my-team", "discover", "players", "invites", "table", "team-page"]),
  leagues: new Set(["overview"]),
  play: new Set(["matches", "create"]),
};

export function getDefaultSubpage(page, { signedIn } = {}) {
  if (page === "account") return "profile";
  if (page === "teams") return signedIn ? "my-team" : "overview";
  if (page === "leagues") return "overview";
  if (page === "play") return "matches";
  return null;
}

export function normalizePageId(page) {
  return PAGE_SET.has(page) ? page : "home";
}

export function normalizeSubpage(page, subpage, { signedIn } = {}) {
  const allowed = ROUTE_SUBPAGES[page];
  if (!allowed) return null;
  if (subpage && allowed.has(subpage)) {
    if (!signedIn && subpage === "my-team") return "overview";
    return subpage;
  }
  return getDefaultSubpage(page, { signedIn });
}

export function buildHashRoute(page, subpage = null, options = {}) {
  const normalizedPage = normalizePageId(page);
  const normalizedSubpage = normalizeSubpage(normalizedPage, subpage, options);
  return normalizedSubpage ? `#/${normalizedPage}/${normalizedSubpage}` : `#/${normalizedPage}`;
}

export function parseRouteFromHash(hash, options = {}) {
  const cleaned = String(hash || "")
    .replace(/^#/, "")
    .replace(/^\/+/, "")
    .trim();

  const [rawPage = "", rawSubpage = ""] = cleaned.split("/").filter(Boolean);
  const page = normalizePageId(rawPage);
  const subpage = normalizeSubpage(page, rawSubpage || null, options);

  return {
    page,
    subpage,
    hash: buildHashRoute(page, subpage, options),
  };
}
